/**
 * Registers the service worker (E6, #446, slice 5) — in a production build
 * only.
 *
 * A worker in `vite dev` serves stale files after an edit and hides the change
 * being made, so development never has one. Push turning itself on does not
 * wait for this: `ensureRegistration` in `push.ts` registers the same worker
 * when someone asks for it, in any build.
 *
 * Registered after `load`, so it never competes with the first paint for the
 * network. A failed registration is silent: the app works without it, and there
 * is nothing a person could do about it.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch(() => undefined);
  });
}
